<template>
  <!-- <div class="pulse-song-item" v-if="song" :class="{promoted: song.NominatedBydbId!=0}">
    <div class="song-container">
      <div v-if="song.NominatedBydbId!=0" class="nomination-attribution">
        <div class="attribution-bar">
          <span>Nominated by <strong @click.stop="goToPlaylistersSpotify(song)">{{song.NominatedByName}}</strong></span>
          <div><strong>{{abbreviateNumber(song.NominatedByFollowers)}} </strong><font-awesome-icon :icon="['fas', 'user-friends']" class="icon" title="Total Followers"></font-awesome-icon></div>
        </div>
        <div class="attributed-to-avatar" @click.stop="goToPlaylistersSpotify(song)"><user-avatar :user="computedUser(song)" class="chat-avatar" :showMenu="false"></user-avatar></div>
      </div>
      <song-cite :track="song" :view="'pulse'" ></song-cite>
    </div>

  </div> -->
  <div class="p-1 pulse-card">
    <div class="card  bg-dark"></div>

  <div :style="'background-image: url(' + thisSong.ArtistImage + ')'" class="card-img-top rounded" :alt="thisSong.ArtistName">
    <div class="ranking">{{ranking}}</div>

  </div>
  <div class="card-body px-0">
    <div class="d-flex flex-row m-0">
      <div class="col flex-grow-1 d-flex flex-column text-left pr-2">
        <p class=" m-0 h6 text-uppercase"><a class="song-name h6 text-uppercase" :href="'https://open.spotify.com/track/' + thisSong.SpotifySongId"  target="_blank">{{thisSong.SongName}}</a></p>
        <p class="artist-name m-0"><span><a  class="link" :href="'https://open.spotify.com/artist/' + thisSong.SpotifyArtistId"  target="_blank"><strong>{{thisSong.SongSpotifyArtistName}}</strong></a></span></p>
        <small v-if="thisSong.NominatedBydbId!=0"><span>Nominated by <a :href="`https://open.spotify.com/user/${thisSong.NominatedBySpotifyUserId}`" class="text-underline" target="_blank"><strong >{{thisSong.NominatedByName}}</strong></a></span></small>
      </div>
      <div class="cover thumbnail d-flex flex-column align-items-center justify-content-center" >
      <SongPreview  :track="formatTrack(song)" :view="'pulse'" class="pulse-song-player" :hideInfo="true" :nocontrols="true"></SongPreview>
      </div>
    </div>

  </div>
</div>
</template>

<script>
import { shared } from '@/main';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default {
  name: 'PulseSong',
  props: {
    song: Object,
    ranking: Number,
    /* {
    SpotifySongId: "3z0WZh7QF88WOok7Ipa2Tb"
    SongName: "Confront Yourself"
    SongImage: "https://i.scdn.co/image/ab67616d0000b273da1a4758c29b11c97771b0a9"
    SongDuration: 238947
    SongPreviewURL: "https://p.scdn.co/mp3-preview/90f100d9adddbab42912d814fbecb53a10992b3f?cid=07003e1d8a61418694c0151cb3f04225"
    SongSpotifyArtistId: "6s4AIbCKY5vBhyHSOBGDCH"
    SongSpotifyArtistName: "Oceans on Orion"
    NominatedBydbId: 0
    NominatedByName: ""
    NominatedByImage: ""
    NominatedBySpotifyUserId: ""
    NominatedByFollowers: ""
    NominatedByUserTier: ""
    Id: "3z0WZh7QF88WOok7Ipa2Tb_0"
    Image: "https://i.scdn.co/image/ab67616d0000b273da1a4758c29b11c97771b0a9"
    } */
  },
  components: {
    FontAwesomeIcon,
    SongPreview: () => import('@/components/SongPreview.vue'),

  },

  data() {
    return {
    };
  },
  computed: {
    thisSong() {
      return {
        ...this.song,
        TrackId: this.song.SpotifySongId,
        Image: this.song.SongImage,
        ArtistName: this.song.SongSpotifyArtistName,
        SpotifyArtistId: this.song.SongSpotifyArtistId,
      };
    },
  },
  methods: {
    computedUser(item) {
      const user = {
        Image: item.NominatedByImage,
        Id: item.NominatedBydbId,
        SpotifyArtistId: item.NominatedBySpotifyUserId,
        UserTier: item.NominatedByUserTier,
        Name: item.NominatedByName,
      };
      return user;
    },
    onTrackClicked() {
      if (this.user) {
        if (this.user.UserType === 'playlister' || this.user.UserType === 'admin') {
          shared.$emit('onStopActiveTrack');

          this.setActiveTrack(null);
          this.setIsActiveTrackPlaying();

          this.showModalWindow('SelectedTrackViewerModal');
          this.setSelectedTrack(this.thisSong);
          this.setActivePanel(null);
          this.setActiveTrack(this.thisSong);
          shared.$emit('onSelectSong', { track: this.thisSong, panel: null });
        } else {
          window.open(`https://open.spotify.com/track/${this.thisSong.TrackId}`);
        }
      }
    },
    goToPlaylistersSpotify(item) {
      window.open(`https://open.spotify.com/user/${item.NominatedBySpotifyUserId}`);
    },
    onOpenInSpotify(track) {
      window.open(`https://open.spotify.com/track/${track.TrackId}`);
    },
    formatTrack(track) {
      const thistrack = track;
      if (!thistrack.TrackId || thistrack.TrackId == null) thistrack.TrackId = thistrack.Id;
      return thistrack;
    },
  },

  mounted() {
    // this.song.TrackId = this.song.SpotifySongId;
    // this.song.Image = this.song.SongImage;
    // this.song.ArtistName = this.song.SongSpotifyArtistName;
    // this.song.SpotifyArtistId = this.song.SongSpotifyArtistId;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped lang="scss">
 @import "@/assets/scss/_sharedvariables.scss";
  .secondary-font{
		font-family: 'League Gothic', sans-serif;
	}
  .pulse-card{
    p{line-height: 120%;}
    a.link{
      color: $secondary;
      font-size: 0.8rem;
      line-height: 100%;
    }
    .song-name{
      color: $white;
    }
    .card-img-top{
      width: 100%;
      padding-top:100%;
        background-size: cover;
        background-position: center center;
        position:relative;
        aspect-ratio: 1;
      .ranking{
        @extend .secondary-font;
        background-color: $primary;
        border-radius: 0.72rem 3px 0.72rem 0.72rem;
        color: $white;
        padding: 0.5rem 1rem;
        position:absolute;
        top: 0.36rem;
        right: 0.36rem;
        font-size: 1.5rem;
        font-weight: 800;
      }
    }
    .thumbnail{
      width: 50px;
      height: 50px;
      background-size:cover;
      border: 1px solid $gray-700;
      box-shadow: inset 0 0 1px 2px rgba($black, 0.5);
      cursor:pointer;
      .icon{
        opacity: 0.75;
      }
      &:hover{
         border: 1px solid $gray-400;
      box-shadow: inset 0 0 1px 1px rgba($black, 0.75);
      .icon{
        opacity:1;
      }
      }
      &:focus{
        border-color: $primary;
      }
    }
  }
// .pulse-song-item{
//   display:flex;
//   flex-flow: row nowrap;
//   padding: 0.9rem;
//   &.promoted{
//     //background-color: $color-black;
//   }
// }

// .song-info{
//   flex:1;
//   display:flex;
//   flex-flow: row wrap;
//   position: relative;

// }
// .nomination-attribution{
//   margin-left: auto;
//   margin-bottom: -10px;
//   z-index:99999991;

//   .icon{
//     color: $color-darkgray;
//   }
// }
// .attribution-bar{
//   text-align: right;
//   color: $color-white;
//   margin-left:auto;
//   align-items: flex-end;
//   padding: 3px 35px 0 1rem;
//   background-color: $color-black;
//   margin-right: 13px;
//   border-radius: 0.5rem 0 0 0;

//   span{
//     strong{

//       cursor:pointer;
//       &:hover{
//         text-decoration: underline;
//         color: lighten($color-secondary, 20%);
//       }
//     }
//     font-size: 0.7rem;
//   }
// }
// .attributed-to-avatar{
//   position: absolute;
//   top:-5px;
//   width: 52px;
//   right: -13px;
//   cursor:pointer;
// }
// .song-container{
//   flex:1;
//   position:relative;
//   display:flex;
//   flex-flow: column nowrap;
// }

//  @media screen and (max-width: $breakpoint-medium){

</style>
